/**
 * 文件说明:
 *
 * globalLayoutContext
 *
 * ----------------------------------------
 * 创建用户: leo
 */
import {createContext, useContext} from 'react'

export const globalLayoutContext = createContext({
    hzHeaderHelp: '',
    setHzHeaderHelp: () => {},
    restoreHzHeaderHelp: () => {},
    setRawHzHeaderHelp: () => {},
})

export function useGlobalLayoutContext() {
    return useContext(globalLayoutContext)
}
